// extracted by mini-css-extract-plugin
export default {"container":"lLuym","inputsRow":"MNDux","addButton":"VLKoA","noProperties":"cj4gt","triggerButtonContainer":"IwRcU","metadataNumber":"QFC7Q"};